import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../authentication/auth.guard';
import { CompanyGuard } from '../companies/company.guard';
import { CalendarOverviewComponent } from './calendar-overview/calendar-overview.component';

export const routes: Routes = [
    { path: '', redirectTo: 'calendar', pathMatch: 'full' },
    {
        path: 'calendar',
        component: CalendarOverviewComponent,
        canActivate: [AuthGuard, CompanyGuard],
    },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
